export default "/static/ffde497946d0e1fc.svg"